/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
if(typeof codazon == 'undefined') {
    codazon = {};
    codazon.disable_zoom = false;
    codazon.thumbnail_slider_type = 0;
}
$.fn.cdzZoom = function(options){
    var defaultConfig = {
        mainImg: '.rsMainSlideImage',
        magnify: '.magnify'
    };
    options = $.extend( {},defaultConfig,options);
    return this.each(function(index, element) {
        var $this = $(this);
        var $magnify = $this.find(options.magnify);
        var $mainImg = $this.find(options.mainImg);
        var nativeWidth = 0;
        var nativeHeight = 0;
        $this.data('cdzZoom',true);
        $this.on('mousemove.cdzZoom',
            function(e){
                if(!nativeWidth && !nativeHeight){
                    var imgObject = new Image();
                    imgObject.src = $mainImg.attr('src');
                    nativeWidth = imgObject.width;
                    nativeHeight = imgObject.height;
                }else{
                    var magnifyOffset = $this.offset();
                    var mx = e.pageX - magnifyOffset.left;
                    var my = e.pageY - magnifyOffset.top;
                }
                if(mx < $this.width() && my < $this.height() && mx > 0 && my > 0){
                    $magnify.fadeIn(100);
                }
                else{
                    $magnify.fadeOut(100);
                }
                if($magnify.is(':visible')){
                    var rx = Math.round(mx/$mainImg.width()*nativeWidth - $magnify.width()/2)*(-1);
                    var ry = Math.round(my/$mainImg.height()*nativeHeight - $magnify.height()/2)*(-1);
                    var bgp = rx + "px " + ry + "px";
                    var px = mx - $magnify.width()/2;
                    var py = my - $magnify.height()/2;
                    $magnify.css({left: px, top: py, backgroundPosition: bgp});
                }
            }
        );
        $this.on('mouseleave.cdzZoom',function(e){
            $magnify.fadeOut(100);
        }); 
    }); 
};
$.fn.moreviewSlider = function(options){
    return this.each(function(){
        var $element = $(this);
        var moreviewSlider = {
            media: '',
            options: {
                thumbs: '.viewmore-thumbs',
                mains: '.viewmore-main',
                imageItem: '.image-item',
                thumbLink: '.thumb-link',
                mainLink: '.main-link',
                defaultType: 'vertical',
            },
            init: function(){
                this.element = $element;
                this.options = $.extend({},this.options,options);
                this._create();
            },
            _create: function(){
                var self = this, config = this.options;
                this.window = $(window);
                this.media = this._getMedia();

                this.$mains = $(config.mains,self.element);
                this.$thumbs = $(config.thumbs,self.element);
                var $mainsCoverWrap = self.$mains.find('.js-cover-wrap').first(), $thumbsCoverWrap = self.$thumbs.find('.js-cover-wrap').first();
                $mainsCoverWrap.prependTo(self.$mains);
                $thumbsCoverWrap.prependTo(self.$thumbs);
                this.$mainLink = $(config.mainLink,self.$mains);
                this.$thumbLink = $(config.thumbLink,self.$thumbs);
                this._initSlider();
                this._attachEvent();
                this._updateSwatch();
            },
            _attachEvent: function(){
                var self = this, config = this.options;
                this.$thumbLink.each(function(i,el){
                    var $tLink = $(this);
                    $tLink.on('click',function(e){
                        e.preventDefault();
                        self.$thumbLink.removeClass('select');
                        $tLink.addClass('select');
                        self.owl = self.$mains.data('owl.carousel');
                        self.owl.to(i,self.owl.options.smartSpeed,true);
                        
                        if(typeof $tLink.data('mainSrc') !== 'undefined'){
                            var $mLink = $(self.$mainLink[i]);
                            var mainSrc = $tLink.data('mainSrc');
                            $mLink.find('img').attr('src',mainSrc);
                        }
                    });
                });
                this.$mainLink.each(function(i,el){
                    var $mLink = $(this);
                    $mLink.on('click',function(e){
                        e.preventDefault();
                    });
                    self._zoom($mLink.parent());
                });
            },
            _getMedia: function(){
                if(this.window.prop('innerWidth') < 768){
                    return 'mobile';
                }else{
                    return 'desktop';
                }
            },
            _initSlider: function(){
                var self = this, config = this.options, vertical;
                self.$firstMain = self.$mains.find('.main-link img').first();
                var img = new Image();
                setTimeout(function(){
                    img.src = self.$firstMain.attr('src');          
                },300);
                $(img).load(function(){
                    self.$thumbs.css('display','');
                    self.$mains.addClass('owl-carousel owl-theme');
                    self.$mains.owlCarousel({
                        items: 1,
                        nav: true,
                        dots: false,
                        margin: 0,
                        rtl: ($('body').css('direction') == 'rtl'),
                        responsive : {
                            0: {
                                dots: true,
                            },
                            768: {
                                dots: false,
                            }
                        },
                        onInitialized: function(){
                            setTimeout(function(){
                                $(config.imageItem,self.element).each(function(){
                                    var $imgItem = $(this);
                                    var $linkImg = $imgItem.find('img').first();
                                    $imgItem.css('display','');
                                    $linkImg.attr('src',$linkImg.data('src'));
                                });
                            },500);
                        }
                    });
                    self.height = self.$mains.height();
                    self.$firstThumb = self.$thumbs.find('.thumb-link img').first();
                    self.owl = self.$mains.data('owl.carousel');
                    img = new Image();
                    self.offset = 0;
                    self.curIndex = 0;
                    self.activeOffset = 0;
                    $(img).load(function(){
                        self.$thumbs.css({position:''});
                        self.$thumbs.lightSlider(self._getSliderSettings(config));
                        self.$thumbLink.each(function(i,el){
                            var $tLink = $(this);
                            $tLink.data('index',i);
                            $tLink.data('mainSrc',$(self.$mainLink[i]).find('img').attr('src'));
                        });
                        self.$mainLink.each(function(i,el){
                            var $mainLink = $(this);
                            $mainLink.data('index',i);
                            if($mainLink.hasClass('product-image')){
                                self.owl.to(i,1,true);
                                $(self.$thumbLink.get(i)).addClass('select');
                            }
                        });
                        var slTimeout = false;
                        self.$mains.on('refreshed.owl.carousel',function(){
                            if(slTimeout){
                                clearTimeout(slTimeout);
                            }
                            slTimeout = setTimeout(function(){
                                var curMedia = self._getMedia();
                                if( (curMedia != self.media) && (config.defaultType == 'vertical')){
                                    self.$thumbs.destroy();
                                    self.$thumbs.removeClass('lSSlide');
                                    self.media = curMedia;
                                    self.$thumbs.lightSlider = $.fn.lightSlider;
                                    self.$thumbs.lightSlider(self._getSliderSettings(config));
                                }else{
                                    self.$thumbs.setConfig(self._getSliderSettings());
                                    self.$thumbs.refresh();
                                }
                                if(!config.vertical){
                                    slTimeout = setTimeout(function(){
                                        self.$thumbs.css({height:''});
                                    },300);
                                }
                            },300);
                        });
                        self.$mains.on('changed.owl.carousel',function(e){
                            var index = e.item.index;
                            var $tLink = $(self.$thumbLink[index]), $mLink = $(self.$mainLink[index]);
                            self.$thumbLink.removeClass('select');
                            $tLink.addClass('select');
                            if(typeof $tLink.data('mainSrc') !== 'undefined'){
                                var mainSrc = $tLink.data('mainSrc');
                                $mLink.find('img').attr('src',mainSrc);
                                var $parent = $mLink.parent();
                                $parent.find('.magnify').css('background',mainSrc);
                                self._zoom($parent);
                                self.$mainLink.removeClass('product-image');
                                $mLink.addClass('product-image');
                            }
                            var offset = Math.floor(index/config.item);
                            if(self.offset != offset){
                                self.$thumbs.goToSlide(offset*config.item);
                                self.offset = offset;
                            }
                            self.curIndex = index;
                        });
                        self.$mains.find('.owl-stage').lightGallery({
                            selectWithin: '.image-item',
                            selector: '.main-link'
                        });
                        $('.rsUni',self.element).click(function(){
                            $('.owl-item.active .main-link',self.element).first().click();
                        });
                    });
                    img.src = self.$firstThumb.attr('src');
                });
            },
            _getSliderSettings: function(){
                var self = this, config = this.options;
                if(config.defaultType == 'vertical'){
                    config.vertical = (self.media == 'desktop');    
                }else{
                    config.vertical = false;
                }
                
                var imgHeight = self.$firstThumb.height();
                var imgWidth = self.$firstThumb.width();
                self.height = self.$mains.height();
                self.width = self.$mains.width();
                if(config.vertical){
                    config.item = Math.floor(self.height/imgHeight);
                    config.slideMargin = Math.max(0,(self.height - (imgHeight+2)*config.item)/config.item);
                }else{
                    imgWidth = Math.max(85,imgWidth);
                    config.item = Math.floor(self.width/imgWidth);
                    config.slideMargin = Math.max(0,(self.width - (imgWidth+2)*config.item)/config.item);
                }
                return {
                    item: config.item,
                    vertical: config.vertical,
                    verticalHeight: self.height,
                    pager: false,
                    slideMargin: config.slideMargin,
                    onAfterSlide: function($el){},
                    onSliderLoad: function($el){
                        if(!config.vertical){
                            self.$thumbs.css({height:''});
                        }
                    }
                }
            },
            _zoom: function($parent){
                if(!codazon.disable_zoom) {
                    $parent.off('mousemove.cdzZoom');
                    $parent.off('mouseleave.cdzZoom');
                    $parent.data('cdzZoom','');
                    $parent.cdzZoom({
                        mainImg: '.main-link > img',
                        magnify: '.magnify' 
                    });
                }
            },
            _updateSwatch: function(){
                var self = this;
                self.window.on('swatchUpdateImage',function(e,swatchImageUrl){
                    var $mLink = $(self.$mainLink.get(self.curIndex))
                    $mLink.find('img').attr('src',swatchImageUrl);
                    var background = 'url('+swatchImageUrl+')';
                    var $parent = $mLink.parent();
                    $parent.find('.magnify').css('background',background);
                    self._zoom($parent);
                });
            }
        }
        moreviewSlider.init();
    });
}

$(document).ready(function () {
  createProductSpin();
  createInputFile();
  coverImage();
  imageScrollBox();

  prestashop.on('updatedProduct', function (event) {
    createInputFile();
    coverImage();
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    imageScrollBox();
    $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
    $('.js-product-images-modal').replaceWith(event.product_images_modal);
  });
    function coverImage(){
        if(codazon.thumbnail_slider_type === 1){
            var defaultType = 'horizontal';
        }else{
            var defaultType = 'vertical';
        }
        $('[data-moreview]').each(function(){
            var $moreviewSlider = $(this);
            $moreviewSlider.moreviewSlider({
                defaultType: defaultType
            });
        });
    }
    function imageScrollBox(){
    
    }
    
  /*function coverImage() {
    $('.js-thumb').on(
      'click',
      (event) => {
        $('.js-modal-product-cover').attr('src',$(event.target).data('image-large-src'));
        $('.selected').removeClass('selected');
        $(event.target).addClass('selected');
        $('.js-qv-product-cover').prop('src', $(event.currentTarget).data('image-large-src'));
      }
    );
  }

  function imageScrollBox()
  {
    if ($('#main .js-qv-product-images li').length > 2) {
      $('#main .js-qv-mask').addClass('scroll');
      $('.scroll-box-arrows').addClass('scroll');
        $('#main .js-qv-mask').scrollbox({
          direction: 'h',
          distance: 113,
          autoPlay: false
        });
        $('.scroll-box-arrows .left').click(function () {
          $('#main .js-qv-mask').trigger('backward');
        });
        $('.scroll-box-arrows .right').click(function () {
          $('#main .js-qv-mask').trigger('forward');
        });
    } else {
      $('#main .js-qv-mask').removeClass('scroll');
      $('.scroll-box-arrows').removeClass('scroll');
    }
  }*/

  function createInputFile()
  {
    $('.js-file-input').on('change',(event)=>{
      $('.js-file-name').text($(event.currentTarget).val());
    });
  }

  function createProductSpin()
  {
    let quantityInput = $('#quantity_wanted');
    quantityInput.TouchSpin({
      verticalbuttons: false,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: parseInt(quantityInput.attr('min'), 10),
      max: 1000000
    });

    quantityInput.on('change', function (event) {
      let $productRefresh = $('.product-refresh');
      $(event.currentTarget).trigger('touchspin.stopspin');
      $productRefresh.trigger('click', {eventType: 'updatedProductQuantity'});
      event.preventDefault();

      return false;
    });
  }
});



// WEBPACK FOOTER //
// ./js/product.js